import { Component, Input } from '@angular/core';

import { BonusModel } from './scorecard-bonus.metadata';

@Component({
    selector: 'cmps-scorecard-bonus',
    template: `
        <div class="cmps-scorecard-bonus--container">
            <span class="cmps-scorecard-bonus--label">{{
                bonusData?.bonusLabel
            }}</span>
            <span class="cmps-scorecard-bonus--value">{{
                bonusData?.value
            }}</span>
        </div>
    `,
    host: {
        class: 'cmps-scorecard-bonus',
    },
})
export class CmpsScorecardBonusComponent {
    @Input() bonusData: BonusModel;
}
